import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../services/auth-service";

@Injectable({
    providedIn: 'root',
})
export class NavigationHelper {

    private authService: AuthService = inject(AuthService);
    private router: Router = inject(Router);

    navigateTo(path: string[]): void {
        this.authService.askToRefreshIfNeeded();
        this.router.navigate(path);
    }

}